export const JSON_PREFIX = "__json=";
export const KEY_PREFIX = "formo";
